<template>
    <div>
        <h3 :data-tracking-codes="trackingCodes.join('|')">Scan labels</h3>

        <p>
            {{ scannedLabelsQuantity }} van {{ labelsTotalQuantity }} gescand
        </p>

        <b-alert :show="hasError" fade variant="danger">
            Fout bij het controleren van het verzendlabel. Probeer het opnieuw, of:
            <b-button variant="outline-danger" size="sm" @click="$emit('fail')">ga toch door</b-button>.
        </b-alert>

        <b-alert :show="isTrackingCodeNotFound" fade variant="warning">
            Barcode niet gevonden<span v-if="labelsTotalQuantity > 1"> of is al gescand</span>.
        </b-alert>

        <b-form @submit.prevent="submit">
            <b-input type="text" v-model.trim="scanValue" class="d-inline-block mr-2" :key="scanCounter /*For re-triggering the autofocus*/"
                     style="width:230px;"
                     placeholder="Barcode"
                     required autofocus autocomplete="off"
                     :disabled="isProcessing"
                     ref="valueInput"
            />
            <b-button variant="primary" type="submit" :disabled="isProcessing">
                <span v-if="!isProcessing">Scan</span>
                <font-awesome-icon v-else icon="spinner" spin/>
            </b-button>
        </b-form>
    </div>
</template>

<script>
export default {
    name: "OrderCompletionScanLabel",

    props: {
        dispatchRequest: {required: true},
    },

    data() {
        return {
            isProcessing: false,
            hasError: false,
            isTrackingCodeNotFound: false,
            scanValue: '',
            trackingCodesPromise: null,
            trackingCodes: [],
            scanCounter: 0, // Wordt gebruikt als key voor de input om de autofocus te triggeren
            refocusInterval: setInterval(() => this.$refs['valueInput']?.focus(), 500),
        }
    },

    computed: {
        labelsTotalQuantity() {
            return this.dispatchRequest?.tracking_codes?.length ?? 0
        },
        scannedLabelsQuantity() {
            return this.labelsTotalQuantity - this.trackingCodes.length
        },
    },

    mounted() {

    },

    beforeDestroy() {
        clearInterval(this.refocusInterval)
    },

    methods: {
        getIdentifier() {
            return 'scan_label'
        },
        isRequired(batchModelType, productIdentifier, dispatchRequest, sortingLocation) {
            this.trackingCodes = (this.dispatchRequest?.tracking_codes ?? []).map(tc => tc.code)
            return Promise.resolve(!!this.trackingCodes.length)
        },
        submit() {
            this.scanCounter++
            this.hasError = false
            this.isTrackingCodeNotFound = false
            this.isProcessing = true

            if (!this.trackingCodes.length) {
                throw new Error("No tracking codes for dispatch request")
            }


            let trackingCodeIndex = this.trackingCodes.indexOf(this.scanValue)
            if (trackingCodeIndex === -1) {
                this.isTrackingCodeNotFound = true
                this.isProcessing = false
                this.scanValue = ''
                return
            }

            const spliced = this.trackingCodes.splice(trackingCodeIndex, 1)

            if (this.trackingCodes.length !== 0) {
                this.isProcessing = false
                this.scanValue = ''
                return;
            }

            this.markAsShipped()
                .catch(() => {
                    this.hasError = true
                    this.isProcessing = false
                    // Re-add the code to make it scannable again
                    this.trackingCodes = this.trackingCodes.concat(spliced)
                    this.scanCounter--
                })
        },
        async markAsShipped() {
            let newDrqData = this.dispatchRequest
            newDrqData.status = 'ready-to-ship'

            return this.$http.post(`/api/rest/process-product/mark-dispatch-request-as-ready-to-ship/${this.dispatchRequest.id}`)
                .then(() => {
                    clearInterval(this.refocusInterval)
                    this.$emit('success', newDrqData)
                })
        },
    },
}
</script>

<style scoped>

</style>
